import { memo, Fragment } from 'react';
import { useTheme } from '@shopify/polaris-viz-core';
import { jsx } from 'react/jsx-runtime';

const HorizontalGridLines = /*#__PURE__*/memo(function HorizontalGridLines({
  ticks,
  transform,
  width
}) {
  const selectedTheme = useTheme();
  return /*#__PURE__*/jsx(Fragment, {
    children: ticks.map(({
      yOffset
    }, index) => /*#__PURE__*/jsx("line", {
      x2: width,
      stroke: selectedTheme.grid.color,
      transform: `translate(${transform.x},${transform.y + yOffset})`
    }, index))
  });
});

export { HorizontalGridLines };
